<template>
  <div>
    <Head
      :title="seoTitle"
      :description="seoDescription"
      :keywords="seoKeywords"
      :json-ld="themeAuction.json_ld"
    />

    <Container>
      <template v-if="themeAuction.has_ended">
        <Link :href="route('frontend.index')">
          <div class="bg-red-500">
            <div class="container mx-auto">
              <div class="text-center font-bold text-xl text-white py-4">
                Deze veiling is afgelopen! Klik hier voor meer mooie aanbiedingen.
              </div>
            </div>
          </div>
        </Link>
      </template>

      <div class="container mx-auto py-8">
        <h1 class="font-bold text-4xl mb-4 md:mb-8">
          {{ themeAuction.name }}
        </h1>

        <div class="flex flex-col md:flex-row md:space-x-4">
          <div class="w-full shrink-0 md:w-[22%]">
            <div class="flex flex-row md:flex-col space-x-4 md:space-x-0">
              <AddToCalendar :theme-auction="themeAuction" />

              <Link
                class="block bg-yellow-400 mb-4 py-2 px-2 xl:px-8 rounded font-bold text-center text-lg md:text-xl text-white uppercase"
                :href="route('frontend.favorites')"
              >
                <span class="block md:hidden">
                  <span class="fa fa-star" />
                </span>
                <span class="hidden md:block">
                  Mijn favorieten ({{ $page.props.customer.number_of_favorites }})
                </span>
              </Link>
            </div>

            <hr class="border-1 border-top border-gray-500 mb-4 md:mb-8">

            <div class="mb-4 md:mb-8">
              <h3 class="font-bold text-lg md:text-2xl md:mb-2">
                Veiling informatie
              </h3>
              <div>
                Aantal kavels: {{ auctions.meta.pagination.total }}
              </div>
              <div>
                Organisator:
                <span class="text-sky-500">
                  {{ themeAuction.created_by.company }}
                </span>
              </div>
            </div>

            <div class="mb-4 md:mb-8">
              <h3 class="font-bold text-lg md:text-2xl md:mb-2">
                Sluiting vanaf
              </h3>
              <template v-if="themeAuction.end_at_past && !themeAuction.has_ended">
                <div class="inline-block font-bold text-uppercase bg-red-500 text-white pt-2 pb-1 px-4 mb-1 md:mb-3">
                  Nu aan het sluiten
                </div>
              </template>
              <div>
                {{ themeAuction.formatted_end_at }} (en daarna)
              </div>
            </div>

            <ThemeAuctionCalendar
              :theme-auction="themeAuction"
              :theme-auction-calendars="themeAuctionCalendar"
              class="hidden md:block"
            />
          </div>
          <div class="grow">
            <div class="space-y-4">
              <template v-if="highlightedAuction">
                <ThemeAuctionBlock
                  :key="`${highlightedAuction.slug}-${highlightedAuction.auction_ends_at}`"
                  :theme-auction="themeAuction"
                  :auction="highlightedAuction"
                  :highlighted="true"
                />
              </template>

              <ThemeAuctionBlock
                v-for="auction in auctions.data"
                :key="`${auction.slug}-${auction.auction_ends_at}`"
                :theme-auction="themeAuction"
                :auction="auction"
              />
            </div>

            <div class="mt-8 mx-auto w-fit">
              <Pagination :pagination="auctions.meta.pagination" />
            </div>
          </div>
        </div>

        <div class="mt-8">
          <ThemeAuctionCalendar
            :theme-auction="themeAuction"
            :theme-auction-calendars="themeAuctionCalendar"
            class="block md:hidden"
          />
        </div>
      </div>
    </Container>
  </div>
</template>

<script>
import {Link} from '@inertiajs/vue2';
import Head from '../../Partials/Head.vue';
import Container from '../../Partials/Container.vue';
import Home from '../../Layouts/Home.vue';
import IndexPageBase from '../../Mixins/IndexPageBase';
import AddToCalendar from './Partials/AddToCalendar.vue';
import ThemeAuctionBlock from '../../Partials/New/ThemeAuctionBlock.vue';
import ThemeAuctionCalendar from './Partials/ThemeAuctionCalendar.vue';
import Pagination from '../../Partials/New/Pagination.vue';

export default {
  components: {
    ThemeAuctionCalendar,
    Container,
    Head,
    Link,
    AddToCalendar,
    ThemeAuctionBlock,
    Pagination,
  },

  mixins: [IndexPageBase],

  layout: Home,

  props: {
    themeAuction: {
      required: true,
      type: Object,
    },

    themeAuctionCalendar: {
      required: true,
      type: Array,
    },

    highlightedAuction: {
      required: false,
      type: Object,
      default: null,
    },

    auctions: {
      required: true,
      type: Object,
    },
  },
};
</script>
